import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const getMailchimpListId = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop/mailchimp-list-id',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}